import { getLang } from '../translations';
import { ResponseSelector } from '../types/globalapi/response-selector';
import { FiltersResponse, FiltersResponseKey, ModelFilterOption } from '../types/globalapi/filters';
import { useAppliedFilterStore } from '../store/filtersv2';
import useFiltersCountQuery from '../api/use-filters-count-query';


export const getSearchButtonCopy = () => {
  const lang = getLang();
  const { labels } = require(`../translations/${lang}.json`);
  let copy;

  const { applied } = useAppliedFilterStore();
  const { category, model: selectedModels } = applied;
  const getModelOptions: ResponseSelector<FiltersResponse, ModelFilterOption[]> = res => res[FiltersResponseKey.MODEL];
  const { data: availableModels } = useFiltersCountQuery({select: getModelOptions});

  if (selectedModels?.length === 0) {
    copy = labels.search_button_disabled;
    return {label: copy};
  }

  let newCount = 0;
  let usedCount = 0;
  let demoCount = 0;

  if (availableModels && selectedModels) {
    selectedModels.map((selectedModel) => {
      (availableModels as ModelFilterOption[]).map((model) => {
        if (model.value === selectedModel) {
          newCount += model.new;
          usedCount += category?.includes("certified") ? model.certified : model.used;
          demoCount += model?.demo || 0;
        }
      });
    });
  }

  if (category?.length === 1 && category?.includes("demo")) {
    copy = labels.search_button_gen;
  } else if (!category?.includes("new") && (category?.includes("used") || category?.includes("certified"))) {
    copy = labels.search_button_used;
  } else if (category?.includes("new") && !category?.includes("used") && !category?.includes("certified")) {
    copy = labels.search_button_new;
  } else {
    copy = labels.search_button_all;
  }

  return {
    totalCount: newCount + usedCount,
    label: copy.replace("%newCount%", newCount).replace("%usedCount%", usedCount).replace("%count%", demoCount)
  }
}
